import DialogFactory from '@kso/ui/lib/Dialog';
import '@kso/ui/lib/Dialog/style.css';
import KReport from '@kso/ui/lib/Report';
import '@kso/ui/lib/Report/style.css';
import KExternalLinkTip from '@kso/ui/lib/ExternalLinkTip';
import '@kso/ui/lib/ExternalLinkTip/style.css';
import { t } from '@kso/ui/lib/config/locale';

var classname = function classname(name) {
  return "k-dialog-".concat(name, "-layout");
};
var index = DialogFactory({
  entry: KReport,
  pages: [
  // 举报文件
  {
    title: t('logic.Report.txt15'),
    className: [classname('report'), classname('share-file')],
    width: '480px',
    body: KReport,
    footer: null,
    closeOnClickModal: false
  }, {
    title: t('logic.Report.txt16'),
    // '打开外部链接'
    className: classname('externalLinkTip'),
    body: KExternalLinkTip,
    footer: null,
    closeOnClickModal: false
  }]
});

export { index as default };
